import {type MeshConstants} from '../types/meshes';

const meshConstants: MeshConstants = {
	colorDepth: 255,
	opacity: 0.5,
};

export default meshConstants;
